import React from 'react';
import ReactDOM from 'react-dom';
import Toast from 'react-toast-mobile';
import 'react-toast-mobile/lib/react-toast-mobile.css';
import './assets/css/index.css';
import './assets/scss/index.scss';
import './assets/scripts/baidu';
import App from './App.tsx';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from '@/redux/index';
import UIAddress from '@/pages/containers/common/ui/address';
import UIConfirm from '@/pages/components/common/ui/confirm';
import config from '@/server/config';


{
	var script = document.createElement('script');
	script.type="text/javascript";
	script.src = config.API+ '/resource/scripts/mhs_sso.js';
	document.head.appendChild(script)
}

if( config.ENV === 'development' ){
    // 手机调试
    ;(function () {
    var src = '//cdn.jsdelivr.net/npm/eruda';
    if (!/eruda=true/.test((window).location) && localStorage.getItem('active-eruda') != 'true') return;
    document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
    document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
    })();
}


ReactDOM.render(
    <Provider store={store}>
        <App />
        <UIAddress />
        <UIConfirm />
        <Toast />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
